// TODO: upgrade to RHF
/**
 * @param {String} phoneNumber
 * @return {Boolean}
 */
export default function checkPhoneNumberLength(phoneNumber) {
  return phoneNumber?.replace(/\D+/g, "").length === 11;
}
